import React, { useState, useEffect } from 'react';
import Loader from "../Shared/Loader/Loader";
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Toast from '../Shared/Toast/Toast';
import { RadioButton } from 'primereact/radiobutton';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../utils/useCatchResponse';
import userImage from '../../assets/images/UserImage.png';
import { apiBase } from '../../utils/config';


const TakeAttendance = () => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState([]);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [childRows, setChildRows] = useState(10);
    const [childFirst, setChildFirst] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date);
    const [attendanceList, setAttendanceList] = useState([]);
    const attendanceOptions = [
        { label: "P", value: "P", color: "green" },
        { label: "A", value: "A", color: "red" },
        { label: "L", value: "L", color: "yellow" },
    ];
    const [classTime, setClassTime] = useState('');
    const [isStudentView, setIsStudentView] = useState(false);
    const [markAllPresent, setMarkAllPresent] = useState(false);
    const [originalAttendanceList, setOriginalAttendanceList] = useState([]);
    const [pageAccess, setPageAccess] = useState({});
    const [modeType, setModeType]  = useState('');

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id, selectedDate);
        const accessData = CommonConfig.getUserAccess('Take Attendance');
        setPageAccess(accessData);
    }, []);

    const formatDateToYMD = (dateObj) => {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const GetClassList = async (id, date) => {
        try {
            let formattedDate = formatDateToYMD(date);
            let data = {
                UserID: id,
                SelectedDate: formattedDate
            }
            Loader.show();
            await api.post(APIConstant.path.GetAttendanceClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetAttendanceList = async (classId,subjectId, classTime) => {
        try {
            let formattedDate = formatDateToYMD(selectedDate);
            let data = {
                UserID: securityUserID,
                ClassId: classId,
                ClassTime: classTime,
                SubjectId: subjectId,
                SelectedDate: formattedDate,
                Type: 'Today'
            }
            Loader.show();
            await api.post(APIConstant.path.GetAttendanceListByClass, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAttendanceList(res?.data?.sort((a, b) => a?.RollNo - b?.RollNo));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const onChildPageChange = (e) => {
        setChildFirst(e.first);
        setChildRows(e.rows);
    };

    const handleEdit = (rowIndex, value) => {
        setAttendanceList((prevItems) => {
            const updatedList = prevItems.map((item, index) =>
                index === rowIndex
                    ? { ...item, AttendanceType: value }
                    : { ...item }
            );
            const allPresent = updatedList.every(
                (item) => item?.AttendanceType === 'P'
            );
            setMarkAllPresent(allPresent);

            return updatedList;
        });
    };

    const handleMarkAllPresent = (checked) => {
        setMarkAllPresent(checked);
        if (checked) {
            setOriginalAttendanceList([...attendanceList]);
            const updatedList = attendanceList.map((student) => ({
                ...student,
                AttendanceType: 'P',
            }));
            setAttendanceList(updatedList);
        } else {
            setAttendanceList(originalAttendanceList);
        }
    };

    const attendanceBodyTemplate = (rows, props) => {
        return (
            <div className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
                {attendanceOptions.map((option, index) => (
                    <div key={index} className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
                        <RadioButton
                            inputId={`attendance-${props.rowIndex}-${option.value}`}
                            name={`attendance-${props.rowIndex}`}
                            value={option.value}
                            disabled={modeType === 'View' ? true: false}
                            checked={rows?.AttendanceType === option.value}
                            onChange={() => handleEdit(props.rowIndex, option.value)}
                        />
                        <label
                            htmlFor={`attendance-${props.rowIndex}-${option.value}`}
                            style={{
                                color: option.color,
                                fontWeight: "bold",
                                cursor: "pointer",
                            }}
                        >
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
        );
    };

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
                    {(rows?.IsTake && pageAccess?.AddAccess) &&
                    <Button label='Take' className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                        GetAttendanceList(rows?.ClassId,rows?.SubjectId, rows?.ClassTime);
                        setClassTime(rows?.ClassTime);
                        setIsStudentView(true)
                        setModeType('New');
                    }} />}
                    {(!rows?.IsTake && pageAccess?.EditAccess) &&
                    <Button label='Edit' className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                         GetAttendanceList(rows?.ClassId,rows?.SubjectId, rows?.ClassTime);
                        setClassTime(rows?.ClassTime);
                        setIsStudentView(true)
                        setModeType('Edit');
                    }} />}
                    <Button label='View' className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                        GetAttendanceList(rows?.ClassId,rows?.SubjectId, rows?.ClassTime);
                        setClassTime(rows?.ClassTime);
                        setIsStudentView(true)
                        setModeType('View');
                    }} />
                </div>
            </React.Fragment>

        );
    };

    const saveAttendance = async () => {
        try {
            const requestData = attendanceList?.map(row => ({
                id: row?.id,
                ClassId: row?.ClassId,
                StudentId: row?.StudentId,
                SubjectId: row?.SubjectId,
                ClassTime: classTime,
                TakenBy: securityUserID,
                AttendanceType: row?.AttendanceType,
                CreatedBy: securityUserID
            }));
            const response = await api.post(APIConstant.path.AddAttendanceDetail, requestData);
            if (response.success) {
                Toast.success({ message: response.message });
                setIsStudentView(false);
                setAttendanceList([]);
                setClassTime('');
                setMarkAllPresent(false);
                GetClassList(securityUserID, selectedDate);
            } else {
                setIsStudentView(false);
                setAttendanceList([]);
                setClassTime('');
                setMarkAllPresent(false);
                GetClassList(securityUserID, selectedDate);
                Toast.error({ message: "Failed to save timetable" });
            }
        } catch (error) {
            setIsStudentView(false);
            setClassTime('');
            setMarkAllPresent(false);
            setAttendanceList([]);
            catchResponse();
        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
            />
            <Button
                label="Update"
                className="p-button-rounded p-button-success p-button-outlined"
                onClick={() => saveAttendance()}
                tooltip="Save Changes"
                tooltipOptions={{ position: "top" }}
            />
        </div>
    );

    const studentNameWithImageTemplate = (rowData) => {
        const imageUrl = rowData?.ProfilePic
            ? `${apiBase}/UserProfilePic/${rowData?.ProfilePic}`
            : userImage;

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img
                    src={imageUrl}
                    alt={rowData.StudentName}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = userImage;
                    }}
                    style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                    }}
                />
            </div>
        );
    };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-window-minimize"></i>
                    <h2>Take Attendance</h2>
                </div>
                <div className="p-grid p-align-center">
                    <label htmlFor="attendanceDate">Attendance Date </label>
                    <div className='searchbar-area'>
                        <Calendar
                            className='p-w-100 p-mt-0'
                            id="attendanceDate"
                            // disabled
                            value={selectedDate}
                            hourFormat="12"
                            dateFormat="dd/mm/yy"
                            onChange={(e) => {
                                setSelectedDate(e.value);
                                GetClassList(securityUserID, e.value)
                            }
                            }
                        />
                    </div>
                </div>
            </div>
            <div>
                <DataTable
                    value={classList}
                    paginator
                    rows={rows}
                    first={first}
                    filterDisplay="menu"
                    responsiveLayout="scroll"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 20]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    onPage={onPageChange}
                    className='custom-table'
                    scrollHeight='calc(100vh - 120px)'
                    size='small'
                >
                    <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                    <Column
                        field="ClassName"
                        header="Class Name"
                    />
                    <Column
                        field='ClassTime'
                        header='Class Time'
                    />
                    <Column
                        field="SubjectName"
                        header="Subject Name"
                    />
                    <Column
                        field='AttendanceData'
                        header='Total Attendance'
                    />
                    <Column
                        header="Action"
                        headerStyle={{ width: '100%' }}
                        body={actionBodyTemplate}
                    />
                </DataTable>
            </div>
            <Dialog
                header={attendanceList ? `${attendanceList[0]?.Classname} (${attendanceList[0]?.SubjectName} - ${classTime})` : ''}
                visible={isStudentView}
                onHide={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
            >
                <div className="p-ai-center">
                    <DataTable
                        value={attendanceList}
                        paginator
                        rows={childRows}
                        first={childFirst}
                        filterDisplay="menu"
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        onPage={onChildPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column
                            field="RollNo"
                            header="Roll No"
                        />
                        <Column header="Student Pic" body={studentNameWithImageTemplate} />
                        <Column
                            field="StudentName"
                            header="Student Name"
                        />
                        <Column
                            field="Attendance"
                            header={
                                <div className="p-d-flex p-ai-center">
                                    <Checkbox
                                        inputId="mark-all-present"
                                        checked={markAllPresent}
                                        disabled={modeType === 'View' ? true: false}
                                        onChange={(e) => handleMarkAllPresent(e.checked)}
                                        tooltip="Mark all Present"
                                    />
                                    <label htmlFor="mark-all-present" style={{ marginLeft: '5px' }}>Attendance</label>
                                </div>
                            }
                            body={attendanceBodyTemplate}
                        />
                    </DataTable>
                </div>
            </Dialog>
        </div>
    );
};

export default TakeAttendance;
